import posthog from 'posthog-js';

/**
 * Manages analytics event tracking using PostHog
 */
class PosthogEvent {
  /**
   * Captures an event when a contractor is added to the system
   * @param email - The email address of the added contractor
   */
  static captureAddContractor({ email }: { email: string }) {
    posthog.capture('Add Contractor', { email });
  }

  static captureAddPaymentMethod() {
    posthog.capture('Add Payment Method');
  }

  static captureEditInvoiceAmount({
    invoiceId,
    oldAmount,
    newAmount,
  }: {
    invoiceId: string;
    oldAmount: number;
    newAmount: number;
  }) {
    posthog.capture('Edit Invoice Amount', {
      invoiceId,
      oldAmount,
      newAmount,
    });
  }

  static captureContractorCreateInvoice({ price, currency }: { price: number; currency: string }) {
    posthog.capture('Contractor Create Invoice', {
      price,
      currency,
    });
  }

  static captureAdminCreateInvoice({ price, currency }: { price: number; currency: string }) {
    posthog.capture('Admin Create Invoice', { price, currency });
  }

  static captureBulkPayInvoices({ price, currency }: { price: number; currency: string }) {
    posthog.capture('Bulk Pay Invoices', { price, currency });
  }

  static captureOnOffCyclePayroll({
    isOnCyclePayroll,
    companyID,
    errorsByCheckId,
  }: {
    isOnCyclePayroll: boolean;
    companyID: string;
    errorsByCheckId: any;
  }) {
    posthog.capture(`W2 ${isOnCyclePayroll ? 'On' : 'Off'}-Cycle Payroll`, {
      companyID,
      errorsByCheckId,
    });
  }

  static captureContractorWithdrawal({
    withdrawalMethodId,
    amount,
    currency,
  }: {
    withdrawalMethodId: string;
    amount: number;
    currency: string;
  }) {
    posthog.capture('Contractor Withdrawal', {
      withdrawalMethodId,
      amount,
      currency,
    });
  }

  static captureBookAMeeting({ email }: { email: string }) {
    posthog.capture('Book a Meeting', {
      email,
    });
  }

  static captureIncorporationCheckoutCreated({ email }: { email: string }) {
    posthog.capture('Incorporation Checkout Created', { email });
  }

  /**
   * Something was picked in the Ask Thera bar. `query` must already be redacted.
   * `resultKind` is what was picked: a command, page, person, contract, recent search or a question.
   * `hadMatches` is false when nothing but the question row was on offer, which marks a gap.
   */
  static captureAskTheraSelect(properties: {
    surface: string;
    mode: 'command' | 'search';
    resultKind: string;
    commandId?: string;
    hadMatches: boolean;
    query: string;
  }) {
    posthog.capture('Ask Thera Select', properties);
  }

  /** The bar was dismissed with something typed and nothing picked. `query` must already be redacted. */
  static captureAskTheraAbandon(properties: { surface: string; mode: 'command' | 'search'; query: string }) {
    posthog.capture('Ask Thera Abandon', properties);
  }
}

export default PosthogEvent;
